/**
 * Servicio de lectura de configuración regional activa.
 * Centraliza el acceso transaccional al perfil del negocio; no actualiza ni interpreta la UI.
 */

import { txRead } from "@/lib/persistence/transactionalStore";
import { getCountryConfig } from "./engine";
import type { CountryConfig } from "./types";

interface StoredCountrySelection {
  pais?: unknown;
}

const BUSINESS_CONFIG_KEY = "businessConfig";

export function getActiveCountryConfig(): CountryConfig {
  const config = txRead<StoredCountrySelection>(BUSINESS_CONFIG_KEY, {});
  return getCountryConfig(config.pais);
}
